import { createStyles, Theme, makeStyles } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
  contentWrapper: {
    display: 'flex',
    '& > div': {
      marginTop: '8px',
    },
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
    width: '70%',
    margin: '0 auto',
  },
  actionsBar: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 auto',
    width: '85%',
    gap: '20px',
    height: '42px',
    '& button': {
      textTransform: 'capitalize',
      '&:last-of-type': {
        marginRight: 0,
      },
    },
  },
  actionButtonsWrapper: {
    '& > *': {
      marginRight: theme.spacing(1),
    },
  },
  backToButton: {
    backgroundColor: '#fff',
    color: theme.appPalette.orange,
  },
  actionButton: {
    backgroundColor: theme.appPalette.orange,
    color: '#fff',
    '&:hover': {
      color: theme.appPalette.orange,
    },
  },
  disabled: {
    color: '#000000',
  },
  rightSide: {
    minHeight: '100%',
    padding: '8px 30px 40px 30px',
    backgroundColor: '#fff',
    boxShadow: theme.shadows[3],
    borderRadius: 10,
  },
  tabsContent: {
    height: '100%',
  },
  spinnerWrapper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  timestamp: {
    color: theme.appPalette.orange,
  },
  paper: {
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)',
    borderRadius: 10,
    padding: 15,
    paddingBottom: 5,
  },
  propertyId: {
    fontSize: 25,
  },
  multiplyDevicesIconsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0 10px',
  },
  icon: {
    fontSize: 20,
    color: '#DB5C0E',
    cursor: 'pointer',
  },
});

const useStyles = makeStyles(styles);

export default useStyles;
